import React from "react";
import loadingGif from "@shared/assets/gif/loading.gif";

/**
 * 라우트(lazy) 청크 로딩 중 표시하는 인라인 폴백.
 * 전체화면 모달(LoadingContainer)과 달리 콘텐츠 영역 중앙에만 표시 → 드로어/앱바를 가리지 않는다.
 */
function RouteFallback() {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                minHeight: 240,
            }}
            aria-live="polite"
            aria-busy="true"
        >
            <img src={loadingGif} alt="loading" style={{ width: 64, height: 64 }} />
        </div>
    );
}

export default RouteFallback;
